module.exports = __webpack_public_path__ + "static/fish2.80afa90a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish2.jpg
// module id = 347
// module chunks = 35783957827783